import { Analytics } from './analytics';
import { AddOnSearchReloadOperation } from '../search';

const productQuery = '[data-ecommerce-product]';

const listName = fetchListNameFromLeftNavigation();

BindProductAnalytics($('body'));

AddOnSearchReloadOperation(BindProductAnalytics);

interface AnalyticsItem {
    id: string;
    list: string;
    quantity: number;
}

function BindProductAnalytics(scope: JQuery<HTMLElement>) {
    let productsAddedToCart: { [productId: string]: any } = {};
    var productsInScope = scope.find(productQuery);

    if (productsInScope.length == 0) {
        return;
    }

    productsInScope.click((e) => {
        manageAddToCart($(e.target));
    });

    manageProductImpressions(productsInScope);

    function manageAddToCart(productElement: JQuery<HTMLElement>) {
        const productAnalytics = parseProductAnalytics(productElement);

        if (productsAddedToCart[productAnalytics.id]) {
            return;
        }

        productsAddedToCart[productAnalytics.id] = productAnalytics;

        productAnalytics.quantity = 1;
        Analytics.sendRawEvent({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'USD',
                add: {
                    products: [productAnalytics],
                },
            },
        });
    }

    function manageProductImpressions(productElements: JQuery<HTMLElement>) {
        var productImpressions = productElements
            .map((i, element) => {
                return parseProductAnalytics($(element));
            })
            .toArray();

        if (productImpressions.length == 0) {
            return;
        }

        Analytics.sendRawEvent({
            ecommerce: {
                detail: {
                    actionField: { list: listName },
                    products: productImpressions,
                },
            },
        });
    }
}

function fetchListNameFromLeftNavigation(): string {
    return $('.left-navigation li.active').text();
}

function parseProductAnalytics(jqueryElement: JQuery<HTMLElement>): AnalyticsItem {
    var product = parseObject(jqueryElement.data('ecommerce-product'));

    if (listName) {
        product.list = listName;
    }

    return product;

    function parseObject(value: any): AnalyticsItem {
        return JSON.parse(decodeHtml(value));
    }

    function decodeHtml(value: any): string {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = value;
        return textArea.value;
    }
}
